const styles = theme => ({
  imageContent: {
    height: 'auto',
    clip:'initial',
  },
  container: {
    backgroundColor: '#fffff',
    overflow: 'hidden',
    width: 'auto',
    height: 'auto',
  },
  imageSize: {
    height:200,
    width:200,
  },
  imageGallery: {
    // regular css.
    width: 400,
  },
  imageGalleryFullscreen: {
    // your full screen css
    width: 600,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/components/User/components/Images/styles.js